import { Wkt } from 'wicket/wicket';

export const errors = errors => {
  const result = {};

  errors.forEach(error => {
    result[error.attribute] = error.errors;
  });

  return result;
};

export const serializeParams = (obj, prefix) => {
  var str = [];
  for(var p in obj) {
    if (typeof obj[p] !== "undefined") {
      var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
      str.push(typeof v === "object" ?
        serializeParams(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

const wkt = new Wkt();
export const convertLocation = (location, fn = false) => {
  if (!location) return null;
  const loc = wkt.read(location);

  if (fn) {
    return {
      lng: () => loc.components[0].x,
      lat: () => loc.components[0].y
    }
  } else {
    return {
      lng: loc.components[0].x,
      lat: loc.components[0].y
    }
  }
}

export const convertPolygon = (paths) => {
  if (!paths) return null;
  const loc = wkt.read(paths);
  return loc.toJson().coordinates.map(multipolygon => {
    return multipolygon.map(polygon => {
      return polygon.map(point => {
        return {
          lng: point[0],
          lat: point[1]
        };
      });
    })
  });
}



// WEBPACK FOOTER //
// ./src/lib/normalize.js